var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSum1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E66100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4219_60577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0516 37.0355C29.0952 32.0525 33.1687 28.001 38.07 28.0877C43.1238 28.1527 47.0666 32.1391 47.023 37.1222C46.9795 42.0619 42.9277 46.0484 38.0047 46.0051C33.0162 45.9617 29.0081 41.9319 29.0516 37.0355ZM41.0326 34.739C40.8801 34.544 40.7494 34.349 40.5751 34.219C40.3137 34.0457 40.0305 34.154 39.8345 34.3707C38.3532 35.8439 36.8501 37.3389 35.3688 38.8338C35.0639 39.1371 35.0639 39.5054 35.3253 39.7654C35.5867 40.0254 35.9788 40.0254 36.262 39.7437C37.765 38.2705 39.2463 36.7755 40.7276 35.2806C40.8583 35.1506 40.9019 34.9773 41.0326 34.739ZM39.9652 39.9171C40.684 39.9171 41.2504 39.3537 41.2504 38.6388C41.2504 37.9455 40.684 37.3822 39.987 37.3605C39.2899 37.3605 38.6799 37.9238 38.6799 38.6388C38.6799 39.3537 39.2463 39.9171 39.9652 39.9171ZM37.3947 35.454C37.3947 34.739 36.8501 34.154 36.1313 34.154C35.4342 34.154 34.8243 34.739 34.846 35.4323C34.846 36.1256 35.4124 36.6889 36.1095 36.7106C36.8066 36.7106 37.4165 36.1472 37.4165 35.454H37.3947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4253 29.1493C21.7977 27.7627 23.1483 26.3978 24.4989 25.0112C27.701 21.7614 30.9032 18.5332 34.1054 15.305C35.0203 14.3734 35.8699 14.3734 36.8066 15.305C37.6126 16.085 38.3968 16.865 39.2027 17.6449C39.4206 17.8616 39.4424 18.0132 39.2245 18.2732C38.4185 19.2482 38.4839 20.5698 39.3335 21.3931C40.183 22.2163 41.5118 22.2597 42.4703 21.4364C42.7317 21.2197 42.8624 21.2414 43.0802 21.458C43.908 22.303 44.7793 23.1263 45.6289 23.9713C46.3913 24.7295 46.4131 25.6612 45.6725 26.4195C44.9972 27.0911 44.3001 27.7411 43.603 28.4127C40.2484 26.4411 36.763 26.1811 33.2558 28.001C29.7487 29.8426 28.006 32.8541 27.7228 36.8622C25.2613 34.2624 22.8433 31.7275 20.4036 29.1493H20.4253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6411 30.1893C20.7739 31.3809 21.9937 32.6591 23.2136 33.9591C24.7167 35.5407 26.2415 37.1439 27.7228 38.7255C27.8535 38.8555 27.9406 39.0288 27.9842 39.2021C28.2674 40.3721 28.7031 41.4987 29.3566 42.4953C29.4873 42.6903 29.4437 42.7769 29.2912 42.9286C28.507 43.7086 27.7446 44.4885 26.9604 45.2685C26.2415 45.9834 25.3048 45.9834 24.586 45.2685C23.8236 44.5102 23.0611 43.7519 22.2769 43.0153C21.9066 42.6686 21.8413 42.3003 22.0155 41.8453C22.5383 40.5021 21.8195 39.1155 20.4689 38.7905C19.9679 38.6822 19.4668 38.7038 18.9876 38.9205C18.5519 39.1155 18.2034 39.0288 17.8766 38.7038C17.1142 37.9239 16.3082 37.1656 15.524 36.3856C14.8705 35.7356 14.8052 34.7824 15.4587 34.1324C16.8093 32.7891 18.2034 31.5109 19.6193 30.1676L19.6411 30.1893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9487 15.6733C27.2652 20.418 22.6471 25.0761 17.9419 29.8209C18.334 28.0443 18.7043 26.3544 19.0964 24.6862C19.7935 21.588 20.4906 18.5115 21.1876 15.4133C21.4273 14.3734 22.1897 13.8751 23.2353 14.0267C23.6927 14.0917 24.1502 14.2 24.6077 14.2867C25.0215 14.3517 25.2612 14.6117 25.3265 15.0017C25.479 15.825 25.9364 16.4099 26.786 16.5616C27.6356 16.7349 28.3326 16.3883 28.8337 15.6733C29.0951 15.305 29.4218 15.175 29.8793 15.2833C30.5546 15.435 31.2298 15.5433 31.9705 15.6733H31.9487Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4219_60577",
    x: 12,
    y: 14,
    width: 38.0234,
    height: 39.0054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4219_60577"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4219_60577",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum1);
export default __webpack_public_path__ + "static/media/sum-1.6396965af25bdcfa5e6a457ee7e844ab.svg";
export { ForwardRef as ReactComponent };